<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel">
                        <h2>Enviar comprovante por SMS</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDeEnvioDeComprovantePorSMS" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-group">
                        <label for="foneCelular">Núm. Celular (informe o DDD)</label>
                        <input type="text" class="form-control" id="foneCelular" name="foneCelular" phoneMask
                            [maskInputId]="'foneCelular'"
                            [preValue]="formularioDeEnvioDeComprovantePorSMS.value.foneCelular"
                            [phoneControl]="formularioDeEnvioDeComprovantePorSMS.controls['foneCelular']" maxlength="16"
                            formControlName="foneCelular">
                        <div *ngIf="formularioDeEnvioDeComprovantePorSMS.controls.foneCelular.invalid && (formularioDeEnvioDeComprovantePorSMS.controls.foneCelular.dirty || formularioDeEnvioDeComprovantePorSMS.controls.foneCelular.touched)"
                            class="alert alert-danger">
                            <div *ngIf="formularioDeEnvioDeComprovantePorSMS.controls.foneCelular.errors">
                                O campo Núm. Celular está inválido.
                            </div>
                        </div>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Enviar"
                                [disabled]="!formularioDeEnvioDeComprovantePorSMS.valid">
                                <mat-icon>phone_android</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="telaAnterior()"
                                matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>